import React, { Fragment, useState } from 'react';
import {  Col, Card, CardBody } from 'reactstrap';
import Rating from 'react-rating';
import HeaderCard from '../../Common/HeaderCard';
import { ThumbsUpDownRating } from '../../../Constant';

const ThumbsUpDownRatingClass = () => {
  const [thumbs, setThumbs] = useState(0);
  return (
    <Fragment>
      <Col xl='6' lg='12' md='6'>
        <Card>
          <HeaderCard title={ThumbsUpDownRating} />
          <CardBody>
            <div className='rating'>
              <Rating initialRating={thumbs} emptySymbol='text-primary fa fa-thumbs-down fa-2x' fullSymbol='text-primary fa fa-thumbs-up fa-2x' onHover={(rate) => setThumbs(rate)}></Rating>
              <span className='current-rating'>{thumbs}</span>
            </div>
          </CardBody>
        </Card>
      </Col>
    </Fragment>
  );
};

export default ThumbsUpDownRatingClass;
